import { useRootAppStore } from "@hooks";
import { observer } from "mobx-react";
import React from "react";

export default observer(function ImagePreviewPopup() {
	const { chatViewStore } = useRootAppStore();

	if (!chatViewStore.imagePreview) {
		return null;
	}

	return (
		<div className="popup popup--full popup--shared">
			<div className="popup__card popup--most__card">
				<div className="popup__header">
					<span>Preview</span>
					<button
						type="button"
						className="btn btn--icon btn--square btn--square--sml btn--primary--inverted"
						onClick={() => chatViewStore.closeImagePreview()}
					>
						<i className="u-icon u-icon--sml u-icon--close" />
					</button>
				</div>
				<div className="popup__body u-padd--reset">
					<img src={chatViewStore.imagePreview} />
				</div>
			</div>
		</div>
	);
});
